<template>
    <div class="col-md-12 table-bordered p-sm">
        <div class="form-group">
            <b>冷氣儲值資訊</b>
        </div>
        <p v-if="loading">冷氣儲值資訊載入中...</p>
        <div v-else-if="!available">
            <p class="text-danger">暫時無法取得冷氣儲值資訊</p>
        </div>
        <div v-else>
            <p>目前餘額:<b>{{ balance != null ? balance : "查無資料" }}</b></p>
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th class="text-center">儲值日期</th>
                        <th class="text-center">金額</th>
                        <th class="text-center">備註</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="depositList.length === 0">
                        <td colspan="3" class="text-center">查無儲值紀錄</td>
                    </tr>
                    <tr v-for="(item, index) in depositList" :key="index">
                        <td class="text-center">{{ item.payDate }}</td>
                        <td class="text-center">{{ item.amount }}</td>
                        <td class="text-center">{{ item.remark }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    props: ["stuId"],
    data() {
        return {
            loading: true,
            available: true,
            balance: null,
            depositList: [],
        };
    },
    mounted() {
        this.load();
    },
    methods: {
        load() {
            this.$axios
                .post("/api/DormitoryAircon/summary", { model: { stuId: this.stuId } })
                .then((resp) => {
                    this.loading = false;
                    const data = (resp.data && resp.data.data) || {};
                    this.available = data.available !== false;
                    this.balance = data.balance;
                    this.depositList = data.depositList || [];
                })
                .catch(() => {
                    this.loading = false;
                    this.available = false;
                });
        },
    },
};
</script>

<style scoped>
</style>
